import { render, staticRenderFns } from "./GenerarBoletines.vue?vue&type=template&id=308e1dc2&"
import script from "./GenerarBoletines.vue?vue&type=script&lang=js&"
export * from "./GenerarBoletines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports